import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
	
	ngOnInit() {
		defineCustomElements(window);
	}
}
